module.exports = "../images/homepage/swimming.jpg";